import {useEffect, useState} from 'react'
import {getPaneliSkartAllDropdown} from '../../../../api/glavnaKnjigaProizvodnje'
import SearchableSelect from '../../../../components/SearchableSelect/SearchableSelect'
import {Option} from '../../../../models/Sektor'
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const PaneliSkartAllDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [PaneliSkartAllDropdown, setPaneliSkartAllDropdown] = useState<Array<Option>>([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getPaneliSkartAllDropdown()
        setPaneliSkartAllDropdown(mapData(response.data))
      } catch (error) {
        console.error('Error fetching dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={PaneliSkartAllDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'PaneliSkartAllDropdown'}
      errors={errors}
      placeholder='Odaberi Paket'
      touched={touched}
    />
  )
}

export default PaneliSkartAllDropdown
